import { useEffect, useRef, useState } from 'react'
import { useCart } from '../../../context/CartContext'
import * as S from './styles'
import CustomerList from '../../../components/Product/CustomerList'
import { useDebounce } from '../../../hooks/useDebounce'
import { IMAGE_URL } from '../../../constants'

const CatalogCartProduct = ({ product }) => {
  const { deleteProductChatbotCart, addProductChatbotCart, chatbotCartComments, setChatbotCartComment, removeChatbotCartComment } = useCart()
  const [qty, setQty] = useState(product.quantity)

  const [hasNote, setHasNote] = useState(false)
  const [productNote, setProductNote] = useState("")
  const prevQtyRef = useRef(qty);
  let firstImage = '/assets/images/empty-image.png'

  if (product.product.images && product?.product?.images?.length > 0) {
    if (product.product.images[0].includes('http')) { 
      firstImage = product.product.images[0] 
    } else { 
      firstImage = `${IMAGE_URL}${product.product.images[0]}` 
    }
  }

  if (product.discount === null) {
    product.discount = 0
  }

  if (product.unitDiscount === null) {
    product.unitDiscount = 0
  }

  const discountSum = product.politicsDiscount + product.politicsUnitDiscount

  const debouncedUpdateCrt = useDebounce((productId, quantity) => {
    addProductChatbotCart(productId, quantity, true)
  }, 800)

  const handleQtyChange = (newQty) => {
    const qtyFormatted = parseFloat(newQty)
    if (qtyFormatted != prevQtyRef.current) {
      setQty(qtyFormatted);
      debouncedUpdateCrt(product.productId, qtyFormatted);
      prevQtyRef.current = qtyFormatted;
    }
  }

  const handleQtyCount = (type) => {
    if (type === 'increase') {
      handleQtyChange(qty + 1)
    } else if (type === 'decrease') {
      if (qty > 1) {
        handleQtyChange(qty - 1)
      } else {
        handleQtyChange(0)
      }
    }
  }

  const handleInputChange = (e) => {
    const value = e.target.value.replace(',', '.')
    if (value === '' || value === '0') {
      setQty('')
      handleQtyChange(0)
    } else {
      const numValue = parseFloat(value)
      if (!isNaN(numValue) && numValue > 0) {
        setQty(numValue)
        handleQtyChange(numValue)
      }
    }
  }

  const handleInputBlur = (e) => {
    const value = e.target.value.replace(',', '.')
    if (value !== '' && value !== '0') {
      handleQtyChange(value)
    } else {
      handleQtyChange(0)
    }
  }

  const handleProductNoteChange = (e) => {
    setProductNote(e.target.value);
    setChatbotCartComment(product.productId, e.target.value);
  }

  const handleEnableProductNoteChange = (e) => {
    setHasNote(e.target.checked);
    if (!e.target.checked) {
      setProductNote("")
      removeChatbotCartComment(product.productId)
    }
  }

  useEffect(() => {
    const storedComment = chatbotCartComments[product.productId] || ""
    setProductNote(storedComment)
    setHasNote(!!storedComment)
    setQty(product.quantity)
  }, [product])

  return (
    <S.CatalogCartProduct key={product.productId}>
      <S.ImageWrapper>
        <S.Image src={firstImage} onError={e => { e.target.src = '/logo.png' }} alt='' />
      </S.ImageWrapper>
      <S.ProductInformationWrapper>
        <S.ProductInformation>
          <S.ProductInformationOnLeft>
            <S.ProductCode>Cód.: #{product.product.id}</S.ProductCode>
            <S.ProductName>
              {/* {product?.product?.sku?.length > 0 ? `${getGradeSelected(product)} -` : ''} */}
              {product.product.description}&nbsp;
              {product.product.multiplicationFactorValue > 1 && product.product.useMultiplicationFactor == true ?
              <S.ProductMultiplicationFactor>(x{product.product.multiplicationFactorValue})</S.ProductMultiplicationFactor> : ""}
            </S.ProductName>
            <S.ProductCharacteristics>
              <CustomerList productId={product.product.id} model='small' isChatbotCatalog />
            </S.ProductCharacteristics>
          </S.ProductInformationOnLeft>

          <S.MobileLayout>
            <S.MobileImageWrapper>
              <S.Image src={firstImage} onError={e => { e.target.src = '/logo.png' }} alt='' />
            </S.MobileImageWrapper>
            <S.MobileProductInformationOnRight>
              <S.ProductQuantityWrapper>
                <S.ProductQuantityButton onClick={() => handleQtyCount('decrease')}>
                  -
                </S.ProductQuantityButton>

                <S.ProductQuantityField
                  type='number'
                  min="1"
                  value={qty}
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}
                />
                <S.ProductQuantityButton onClick={() => handleQtyCount('increase')}>
                  +
                </S.ProductQuantityButton>
              </S.ProductQuantityWrapper>
              <S.ProductTotalValue>
                {(product.value * qty).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
                <S.CartDeleteProductBtn onClick={() => deleteProductChatbotCart(product.productId)}>
                  <S.CartIcon type='trash' />
                </S.CartDeleteProductBtn>
              </S.ProductTotalValue>
            </S.MobileProductInformationOnRight>
          </S.MobileLayout>

          <S.ProductInformationOnMid>
            <S.ProductValuesWrapper>
              <S.ProductValueDescription>Valor Unitário</S.ProductValueDescription>
              <S.ProductValue>
                {product.value.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </S.ProductValue>
            </S.ProductValuesWrapper>
            <S.ProductValuesWrapper>
              <S.ProductValueDescription>Desconto</S.ProductValueDescription>
              <S.ProductValue className='value'>{discountSum.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
              </S.ProductValue>
            </S.ProductValuesWrapper>
            <S.ProductValuesWrapper>
              <S.ProductValueDescription>Impostos</S.ProductValueDescription>
              <S.ProductValue>
                {product.tax.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </S.ProductValue>
            </S.ProductValuesWrapper>
            <S.ProductValuesWrapper>
              <S.ProductValueDescription>Frete</S.ProductValueDescription>
              <S.ProductValue>
                {product.freight.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </S.ProductValue>
            </S.ProductValuesWrapper>
          </S.ProductInformationOnMid>


          <S.ProductInformationOnRight>
            <S.ProductQuantityWrapper>
              <S.ProductQuantityButton
                onClick={() => handleQtyCount('decrease')}
              >
                -
              </S.ProductQuantityButton>

              <S.ProductQuantityField
                type='number'
                min="1"
                value={qty}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
              />
              <S.ProductQuantityButton
                onClick={() => handleQtyCount('increase')}
              >
                +
              </S.ProductQuantityButton>
            </S.ProductQuantityWrapper>
            <S.ProductTotalValue>
              {(product.value * qty).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
            </S.ProductTotalValue>
            <S.CartDeleteProductBtn onClick={() => deleteProductChatbotCart(product.productId)}>
              <S.CartIcon type='trash' />
            </S.CartDeleteProductBtn>
          </S.ProductInformationOnRight>
        </S.ProductInformation>


        <S.ProductInformationOnBottom>
          <S.ProductCommentWrapper>
            <S.ProductActivateCommentInput
              value={hasNote}
              onChange={handleEnableProductNoteChange} 
              type='checkbox' 
              name='' 
              id={product.productId} 
              placeholder=''
              checked={hasNote}
            />
            <S.ProductCommentLabel htmlFor={product.productId}>Adicionar um comentário a este item</S.ProductCommentLabel>
          </S.ProductCommentWrapper>
          {hasNote &&
            <S.ProductCommentTextarea
              value={productNote}
              onChange={handleProductNoteChange}
              style={{ width: '100%', height: '150px' }}
              placeholder='Deixe aqui seu comentário...'
            />
          }
        </S.ProductInformationOnBottom>
      </S.ProductInformationWrapper>
    </S.CatalogCartProduct>
  )
}

export default CatalogCartProduct